import { InjectionToken } from '@angular/core';
import type { Analytics } from 'firebase/analytics';

export const FIREBASE_ANALYTICS = new InjectionToken<Analytics>('FIREBASE_ANALYTICS');
